import { render, staticRenderFns } from "./assetView.vue?vue&type=template&id=71230475&scoped=true"
import script from "./assetView.vue?vue&type=script&lang=js"
export * from "./assetView.vue?vue&type=script&lang=js"
import style0 from "./assetView.vue?vue&type=style&index=0&id=71230475&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71230475",
  null
  
)

export default component.exports